import React from 'react'
import {Link} from 'react-router-dom'
import Breadcumb from '../../Breadcumb/Main'
import BgImg from  "../../../assets/images/blog/careers.png"
import jobs from '../../../data/jobs'

const Blogs = () => {
    return (
        <>
            <Breadcumb Title="Careers" Breadcumb="Careers" BgImg={BgImg} />
            <section className="section-padding--top section-padding--bottom">
                <div className="container">
                    <div className="row gutter-y-30">
                        {jobs.map((job, index) => (
                            <div key={job.slug} className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${(index % 6) * 100}ms`}>
                                <div className="blog-card-one">
                                    <div className="blog-card-one__content">
                                        <div className="blog-card-one__meta">
                                            <div className="blog-card-one__date">
                                                <i className="fa fa-briefcase" aria-hidden="true"></i>
                                                {job.type}
                                            </div>
                                            <span className="blog-card-one__category">{job.category}</span>
                                        </div>
                                        <h3 className="blog-card-one__title">
                                            <Link to={`/job-details/${job.slug}`}>{job.title}</Link>
                                        </h3>
                                        <Link to={`/job-details/${job.slug}`} className="blog-card-one__more">
                                            View Role
                                            <i className="fa fa-arrow-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blogs
